import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useModalEffect from '../../../hooks/useModalEffect';

const MODAL_ID = 'modal-view-currency-rate';

const ViewCurrencyRate = ({ isOpen, onClose, data }) => {
  useModalEffect(isOpen);
  ;

  useEffect(() => {
    return () => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, []);


  if (!data) return null;

  const formatRate = (rate) =>
    new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(rate);

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString('id-ID') : '-');

  return (
    <div
      className={`modal modal-blur fade${isOpen ? ' show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }}
      id={MODAL_ID}
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">View Currency Rate Details</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col-4 fw-bold">Currency Code</div>
              <div className="col-8">{data.currency_code}</div>
            </div>
            <div className="row mb-3">
              <div className="col-4 fw-bold">Currency Name</div>
              <div className="col-8">{data.currency_name}</div>
            </div>
            <div className="row mb-3">
              <div className="col-4 fw-bold">Exchange Rate (IDR)</div>
              <div className="col-8">Rp {formatRate(data.exchange_rate)}</div>
            </div>
            <div className="row mb-3">
              <div className="col-4 fw-bold">Start Date</div>
              <div className="col-8">{formatDate(data.start_date)}</div>
            </div>
            <div className="row mb-3">
              <div className="col-4 fw-bold">End Date</div>
              <div className="col-8">{formatDate(data.end_date)}</div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

ViewCurrencyRate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default ViewCurrencyRate;
